<template>
    <div>
        <div class="product_menu">
            <dl class="pageCenter" id="product_menu">
                <dt data-menuanchor="page1"><a href="#page1" title="唐麦耳机F0">Tangmai F0</a></dt>
                <dd data-menuanchor="page2"><a href="#page2">概览</a></dd>
                <dd data-menuanchor="page3"><a href="#page3">设计</a></dd>
                <dd data-menuanchor="page4"><a href="#page4">音质</a></dd>
                <dd data-menuanchor="page5"><a href="#page5">耳帽</a></dd>
                <dd data-menuanchor="page6"><a href="#page6">品质</a></dd>
                <dd data-menuanchor="page7"><a href="#page7">体验</a></dd>
                <dd data-menuanchor="page8"><a href="#page8">参数</a></dd>
                <!--<dd><a href="images_f0.html#page2">图集</a></dd>-->
            </dl>
        </div>
        <div id="product" style="z-index:1;" v-if="platform == 1">
            <!-- 头部 -->
            <div class="section header active fp-auto-height">
                <v-header></v-header>

                <div class="product_menu2">
                    <dl class="pageCenter">
                        <dd data-menuanchor="page2"><a href="#page2">概览</a></dd>
                        <dd data-menuanchor="page3"><a href="#page3">设计</a></dd>
                        <dd data-menuanchor="page4"><a href="#page4">音质</a></dd>
                        <dd data-menuanchor="page5"><a href="#page5">耳帽</a></dd>
                        <dd data-menuanchor="page6"><a href="#page6">品质</a></dd>
                        <dd data-menuanchor="page7"><a href="#page7">体验</a></dd>
                        <dd data-menuanchor="page8"><a href="#page8">参数</a></dd>
                        <!--<dd><a href="images_f0.html#page2">图集</a></dd>-->
                    </dl>
                </div>
            </div>

            <div class="section product_li" style=" background:url(http://ww3.sinaimg.cn/large/0067mezugw1eyseaj9vdcj33io140wvp.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww4.sinaimg.cn/large/0067mezugw1eyseajyjqwj30de03d74h.jpg" height="100" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww2.sinaimg.cn/large/0067mezugw1eyseakedwbj33io1404gw.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww4.sinaimg.cn/large/0067mezugw1eyseakl626j30jn03daah.jpg" height="100" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww3.sinaimg.cn/large/0067mezugw1eyseakwvpxj33io140qkf.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww4.sinaimg.cn/large/0067mezugw1eysealffsnj30fw03djro.jpg" height="100" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww3.sinaimg.cn/large/0067mezugw1eysealngabj33io14013y.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww1.sinaimg.cn/large/0067mezugw1eyseam57gcj30mm03dgm1.jpg" height="100" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww3.sinaimg.cn/large/0067mezugw1eyseamit87j33io140wtv.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww2.sinaimg.cn/large/0067mezugw1eysean36qlj30jw03djru.jpg" height="100" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww4.sinaimg.cn/large/0067mezugw1eyseanfxgkj33io14045a.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww2.sinaimg.cn/large/0067mezugw1eyseao1iuij30e307h3yy.jpg" height="200" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww3.sinaimg.cn/large/0067mezugw1eyseaokn8wj33io140wty.jpg) center; background-size:auto 100%;">
            <div class="pageCenter">
            	<p style=" top:20%; text-align:left; width:100%;"><img src="http://ww2.sinaimg.cn/large/0067mezugw1eyseaoteyhj3077026mx4.jpg" height="66" /></p>
				<!--<p class="p2" style="height:46%;"><img src="images/f0/f0_07_p2.png" height="100%" /></p>-->
                <div class="product_data">
                	<ul>
                    	<li class="left">
                        	<div class="data_box"><p class="data_p1">频响范围</p>
                        	<p class="data_p2">Frequency range</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">20-20000HZ</p>
                            <p class="data_p2">20-20000HZ</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">阻抗</p>
                        	<p class="data_p2">Impedance</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">16Ω</p>
                            <p class="data_p2">16Ω</p>
                            </div>
                        </li>
						<li class="left">
                        	<div class="data_box"><p class="data_p1">接口类型</p>
                        	<p class="data_p2">Interface type</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">3.5mm插头</p>
                            <p class="data_p2">3.5mm plug</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">声压</p>
                        	<p class="data_p2">Sound pressure</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">96db</p>
                            <p class="data_p2">96db</p>
                            </div>
                        </li>
						<li class="left">
                        	<div class="data_box"><p class="data_p1">驱动单元</p>
                        	<p class="data_p2">Drive unit</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">8.0mm</p>
                            <p class="data_p2">8.0mm</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">线长</p>
                        	<p class="data_p2">Line length</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">1.2m</p>
                            <p class="data_p2">1.2m</p>
                            </div>
                        </li>
						
						<li class="left">
                        	<div class="data_box"><p class="data_p1">灵 敏 度</p>
                        	<p class="data_p2">Sensitivity degree</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">108db</p>
                            <p class="data_p2">108db</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">线材</p>
                        	<p class="data_p2">Wire rod</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">面条线</p>
                            <p class="data_p2">Noodle line</p>
                            </div>
                        </li>
						<li class="left">
                        	<div class="data_box"><p class="data_p1">是否线控</p>
                        	<p class="data_p2">Whether by wire</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">是（手机版）</p>
                            <p class="data_p2">Is (mobile version)</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">指向</p>
                        	<p class="data_p2">Point</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">全指向</p>
                            <p class="data_p2">Full point</p>
                            </div>
                        </li>
                    </ul>
                </div>
				<div class="clear"></div>
            </div>
			<div class="clear"></div>
        </div>

            <!-- 尾部 -->
            <div class="section fp-auto-height fp-section">
                <v-footer></v-footer>
            </div>
            
        </div>

        <div id="mobile" v-else>
            <!--手机端头部-->
            <v-header></v-header>
            <div class="mobile_pageMain">
                <div class="tools">
                    <span class="span1">产品</span>
                    <span class="span2">唐麦 F0</span>
                </div>
                <img class="productImg" style="margin-top:40px;" src="http://ww4.sinaimg.cn/large/0067mezugw1f1m0ysm2fmj30k00frdgw.jpg" />
                <img class="productImg" src="http://ww2.sinaimg.cn/large/0067mezugw1f1m0ysxosuj30k00frabc.jpg" />
                <img class="productImg" src="http://ww4.sinaimg.cn/large/0067mezugw1f1m0yt41wej30k00frt9u.jpg" />
                <img class="productImg" src="http://ww2.sinaimg.cn/large/0067mezugw1f1m0ytl6p9j30k00frmxx.jpg" />
                <img class="productImg" src="http://ww1.sinaimg.cn/large/0067mezugw1f1m0yuap5zj30k00frwgd.jpg" />
                <img class="productImg" src="http://ww3.sinaimg.cn/large/0067mezugw1f1m0yug0zaj30k00frjs8.jpg" />
                <img class="productImg" src="http://ww1.sinaimg.cn/large/0067mezugw1f1m0yuu02dj30k008cq3i.jpg" />
                <img class="productImg" src="http://ww1.sinaimg.cn/large/0067mezugw1f1m0yve8nkj30k00kiacl.jpg" />
            </div>
            <v-footer></v-footer>
        </div>
        <!-- 回到顶部 -->
        <a href="#page1"><goto-top></goto-top></a>
    </div>
</template>
<script>
//引入fullpage
import "../../assets/libs/fullpage/jquery.fullPage.css"
import "../../assets/libs/fullpage/jquery.fullPage.min.js"
import "../../assets/css/style.css"
    export default{
        data(){
            return {
                platform: 1   //1 pc端   2 mobile端
            }
        },
        mounted(){
            if($(window).width() > 786){
                this.platform = 1;
                var $mlNav = $('.product_menu');
                $('#product').fullpage({
                    verticalCentered: !1,
                    navigation: !0,
                    anchors: ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9'],
                    menu: '#product_menu',
                    onLeave: function(index, nextIndex, direction){
                        if(index == 2 && direction == 'up'){
                            $mlNav.animate({
                                top: -100
                            }, 0);
                        } else if(index == 1 && direction == 'down') {
                            $mlNav.animate({
                                top: 0
                            }, 500);
                            $(".headmenu_two").hide();
                        }
                        if(nextIndex == 1){
                            $mlNav.animate({
                                top: -100
                            }, 0);
                        }
                        if(nextIndex == 9){
                            $mlNav.hide();
                        }else{
                            $mlNav.show();
                        }
                    },
                    afterLoad: function(anchorLink, index){
                        //$(".product_li").css("height", $("#product").height());
                        
                        /*回到顶部*/
                        if(index == 1 || index == 2){
                            $(".gotoTop").hide();
                        }else{
                            $(".gotoTop").show();
                        }
                    }
                })
            }else{
                this.platform = 2;
            }
        },
        destroyed(){
            var html = document.querySelector("html");
            var width = html.getBoundingClientRect().width;
            //设置 1rem = width/16
            if(width >= 768){
                //去除fullpage插件设置的100%高度和隐藏溢出
                $("html, body").removeAttr("style");
                $("html, body").removeAttr("class");
            }
        }
    }
</script>
<style scoped>
@media (min-width: 768px){
    .header-wrap{
        position: relative !important;
    }
}
    

    
</style>


// WEBPACK FOOTER //
// src/pages/products/f0.vue